import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("path", {
  d: "M9 18V5l12-2v13"
}), ___EmotionJSX("circle", {
  cx: "6",
  cy: "18",
  r: "3"
}), ___EmotionJSX("circle", {
  cx: "18",
  cy: "16",
  r: "3"
}));
export default SVG;